import { FC, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useContextSelector } from 'use-context-selector';

import { getUserProfileAddresses } from '@/core/apis/orders-apis';
import { authSelector } from '@/core/store/global/app-states';
import { AppContext } from '@/core/store/global/AppProvider';
import { Button } from '@/ux/components/shadcn/ui/button';
import { Input } from '@/ux/components/shadcn/ui/input';
import countries from '@/ux-legacy/uikit/elements/inputs/CountryPicker001/data/countries.json';

type AddressCaptureProps = {
  onNext: any;
  onBack: any;
  setAddressData: any;
  addressData: any;
  stage: number;
};
const AddressCapture: FC<AddressCaptureProps> = ({ onNext, setAddressData, addressData, stage, onBack }) => {
  const [savedAddresses, setSavedAddresses] = useState<any>([]);
  const authentication = useContextSelector(AppContext, authSelector);
  const {
    register,
    reset,
    trigger,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Line1: addressData?.Line1 || '',
      Line2: addressData?.Line2 || '',
      City: addressData?.City || '',
      State: addressData?.State || '',
      Country: addressData?.Country || '',
      ZipCode: addressData?.ZipCode || '',
    },
  });

  useEffect(() => {
    if (authentication?.loggedIn) {
      fetchSavedAddresses();
    }
  }, [authentication]);

  const fetchSavedAddresses = async () => {
    getUserProfileAddresses().then((res: any) => {
      setSavedAddresses(res);
    });
  };

  const formReset = (values: any) => {
    reset(values);
  };

  const handleSubmitForm = async () => {
    const valid = await trigger();
    if (valid) {
      setAddressData(getValues());
      onNext();
    }
  };

  const onSelectAddress: any = (e: any) => {
    const address = savedAddresses?.find((address: any) => address?.guid == e.target.value);

    if (address) {
      const { Line1, Line2, City, State, Country, ZipCode } = address;
      formReset({ _id: address?.guid, Line1, Line2, City, State, Country, ZipCode });
    } else {
      formReset({ Line1: '', Line2: '', City: '', State: '', Country: '', ZipCode: '' });
    }
  };
  return (
    <div className="flex gap-2 flex-col h-full">
      <div className="grow overflow-y-auto">
        <div className="space-y-4">
          <div className="p-2 rounded-md space-y-2">
            {authentication?.loggedIn && (
              <select
                className="w-full border-gray-200 rounded-md focus:border-gray-200 focus:ring-gray-200"
                onChange={onSelectAddress}
              >
                <option>Select saved or enter new address...</option>
                {savedAddresses?.map((address: any) => {
                  return (
                    <option value={address?.guid} key={address?.guid}>
                      {address?.Line1}
                    </option>
                  );
                })}
              </select>
            )}
            <div>
              <Input placeholder="Address Line 1" {...register('Line1')} />
              <p className="flex justify-between text-slate-400 text-sm">
                <div>
                  {errors.Line1 && <span className="text-red-500">{`Address Line1 is Required`}</span>}
                </div>
              </p>
            </div>
            <div>
              <Input placeholder="Address Line 2" {...register('Line2')} />
              <p className="flex justify-between text-slate-400 text-sm">
                <div>
                  {errors.Line2 && <span className="text-red-500">{`Address Line2 is Required`}</span>}
                </div>
              </p>
            </div>

            <div>
              <Input placeholder="City" {...register('City')} />
              <p className="flex justify-between text-slate-400 text-sm">
                <div>{errors.City && <span className="text-red-500">{`City is Required`}</span>}</div>
              </p>
            </div>
            <div>
              <Input placeholder="State" {...register('State')} />
              <p className="flex justify-between text-slate-400 text-sm">
                <div>{errors.State && <span className="text-red-500">{`State is Required`}</span>}</div>
              </p>
            </div>

            <div>
              <select
                {...register('Country')}
                className="w-full border-gray-200 rounded-md focus:border-gray-200 focus:ring-gray-200"
              >
                {countries?.map((country: any) => {
                  return (
                    <option value={country?.name} key={country?.name}>
                      {country?.name}
                    </option>
                  );
                })}
              </select>
              <p className="flex justify-between text-slate-400 text-sm">
                <div>{errors.Country && <span className="text-red-500">{`Country is Required`}</span>}</div>
              </p>
            </div>

            <div>
              <Input placeholder="Zip Code" {...register('ZipCode')} />
              <p className="flex justify-between text-slate-400">
                <div>{errors.ZipCode && <span className="text-red-500">{`Required`}</span>}</div>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`flex p-2 ${authentication?.loggedIn || stage > 0 ? 'justify-between' : 'justify-end'}`}
      >
        <div className="flex gap-2">
          {stage > 0 && (
            <Button onClick={onBack} className="bg-black text-white">
              Back
            </Button>
          )}
        </div>

        <Button onClick={handleSubmitForm} className="bg-black text-white">
          Next
        </Button>
      </div>
    </div>
  );
};

export default AddressCapture;
